var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4762 16.4643C19.7417 16.4643 16.7143 19.4917 16.7143 23.2262C16.7143 26.9607 19.7417 29.9881 23.4762 29.9881C27.2107 29.9881 30.2381 26.9607 30.2381 23.2262C30.2381 19.4917 27.2107 16.4643 23.4762 16.4643ZM15 23.2262C15 18.5449 18.7949 14.75 23.4762 14.75C28.1575 14.75 31.9524 18.5449 31.9524 23.2262C31.9524 27.9075 28.1575 31.7024 23.4762 31.7024C18.7949 31.7024 15 27.9075 15 23.2262Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4574 28.2071C28.7921 27.8724 29.3348 27.8724 29.6696 28.2071L34.7489 33.2865C35.0837 33.6212 35.0837 34.1639 34.7489 34.4987C34.4142 34.8334 33.8715 34.8334 33.5367 34.4987L28.4574 29.4193C28.1226 29.0846 28.1226 28.5418 28.4574 28.2071Z",
    fill: "#B4B4B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1303 26.942C30.6029 26.9701 30.9632 27.376 30.935 27.8485C30.8898 28.609 30.7376 29.3462 30.1925 29.8861C29.6635 30.4102 28.9214 30.5876 28.15 30.6804C27.68 30.7369 27.2532 30.4017 27.1966 29.9317C27.1401 29.4617 27.4753 29.0349 27.9453 28.9783C28.6602 28.8924 28.8919 28.7615 28.9861 28.6682C29.0643 28.5908 29.1848 28.4015 29.2238 27.7467C29.2519 27.2741 29.6578 26.9138 30.1303 26.942Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a443f2a0a1a1f075e8ca9b6f11719698.svg";
export { ForwardRef as ReactComponent };